import { forwardRef } from "react"
import ReactDatePicker from "react-datepicker";
import CustomImage from "./CustomImage";
import calender from '../Asset/image/calender.png';
import "react-datepicker/dist/react-datepicker.css";
const RenderInput = forwardRef(({ value, onClick, inputClassName, required, imageStyle }, ref) => {
    return (
        <div className={inputClassName} onClick={onClick} ref={ref} style={{ marginTop: "30px" }}>
            {/* <img src={"/images/calnder.png"} alt="" style={imageStyle || { width: "22px", height: "22px", position: "absolute", borderRadius: "0px", marginBlock: "17px", left: "20px" }} /> */}
            <CustomImage src={calender} className="profileIcon" style={{ marginTop: "30px" }} />
            <input
                className="input-box px-4 ms-3 bg-transparent"
                value={value}
                placeholder={"Date of birth DD/MM/YY"}
                disabled
            />
        </div>
    );
});

const DateInput = ({ value, onChangeDate, inputClassName, required, minDate, maxDate, imageStyle, disabled }) => {
    return (
        <ReactDatePicker
            dateFormat="dd/MM/yy"
            selected={value}
            disabled={disabled}
            minDate={minDate || new Date("01-01-1720")}
            maxDate={maxDate}
            showMonthDropdown
            required={required}
            showYearDropdown
            yearDropdownItemNumber={300}
            scrollableYearDropdown
            onChange={(date) => onChangeDate(date)}
            customInput={<RenderInput imageStyle={imageStyle} inputClassName={inputClassName} required={required} />}
        />)
}
export default DateInput;